import { render, staticRenderFns } from "./TypeActions.vue?vue&type=template&id=4ad9d218&scoped=true&"
import script from "./TypeActions.vue?vue&type=script&lang=js&"
export * from "./TypeActions.vue?vue&type=script&lang=js&"
import style0 from "./TypeActions.vue?vue&type=style&index=0&id=4ad9d218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad9d218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ad9d218')) {
      api.createRecord('4ad9d218', component.options)
    } else {
      api.reload('4ad9d218', component.options)
    }
    module.hot.accept("./TypeActions.vue?vue&type=template&id=4ad9d218&scoped=true&", function () {
      api.rerender('4ad9d218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform/components/TypeActions.vue"
export default component.exports